import {Button} from "reactstrap";
import React from "react";

export const ErrorView = ({error, children, retry}) => {
    return error ? <div className="p-lg-5 text-center">
        <i className="fa fa-exclamation-triangle" style={{color: "red", fontSize: "4em"}}/>
        <p className="error-hint mt-2">{error}</p>
        {retry && <Button onClick={retry}><i className="fa fa-refresh"/> Try again</Button>}
    </div> : children;
};



// WEBPACK FOOTER //
// ./src/components/TractorRequestBuilder/ErrorView.js